import React from 'react';
import { createBrowserRouter } from 'react-router-dom';
import routes from './routes';
import PrivateRoute from './components/Common/PrivateRoute';
import PageNotFound from './components/Common/PageNotFound';

const router = createBrowserRouter([
  ...routes.map(({ path, component: Component, private: isPrivate }) => ({
    path,
    element: isPrivate ? (
      <PrivateRoute path={path}>
        <Component />
      </PrivateRoute>
    ) : (
      <Component />
    )
  })),
  { path: '*', element: <PageNotFound /> }
]);

export default router;
